import vi from "./vn.translation.json";
import en from "./en.translation.json";

export const TRANSLATE = {
  vi,
  en
};
